export default "__VITE_ASSET__CgEmzhQu__"